(function ($, Drupal) {
  'use strict';

  /**
   * Trigger artist favorites slick carousel
   */
  Drupal.behaviors.artistFavesV1 = {
    attach: function (context) {
      var faveFormatter = $('.artist-favorite-products-v1');

      faveFormatter.each(function () {
        var faveFormatter = $(this);
        var faveCarousel = faveFormatter.find('.js-artist--products__carousel');
        var faveSlide = '.carousel-slide';
        var arrowsDiv = faveFormatter.find('.carousel-controls');
        var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;
        // swipe/drag direction is opposite when in RTL
        // so better to just disable it until a fix is provided in the library
        var swipe = isRTL ? false : true;
        var draggable = swipe;

        faveCarousel.slick({
          rtl: isRTL,
          swipe: swipe,
          draggable: draggable,
          appendArrows: arrowsDiv,
          autoplay: false,
          speed: 300,
          slide: faveSlide,
          slidesToShow: 4,
          slidesToScroll: 1,
          accessibility: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ],
          onInit: function () {
            var clonedSlide = faveCarousel.find('.slick-cloned .product__sku-details');

            clonedSlide.attr('id', 'product-detail-attach');
          }
        });
      });

      $('.js-artist-signature__image', context).each(function () {
        var $img = $(this);
        var img = new Image();

        img.src = $img.attr('src');
        img.onload = function () {
          $img.attr('width', img.naturalWidth);
          $img.attr('height', img.naturalHeight);
        };
      });
    }
  };
})(jQuery, Drupal);
